import React from 'react';
import {connect} from 'react-redux';
import { Redirect } from 'react-router-dom';
import {logout} from "../../actions/auth"

import {
  MdDashboard,
  MdExtension,
  MdKeyboardArrowDown,
  MdExitToApp,
} from 'react-icons/md';
import {
  FaChartLine,
  FaHistory,
  FaGasPump,
  FaCarAlt,
  FaUserTie,
  FaCheck,
  FaUsersCog,
  FaUsers,
  FaFile,
  FaKey,
  FaRegUserCircle,
  FaClipboardCheck,
} from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import {
  Collapse,
  Nav,
  Button,
  Navbar,
  NavItem,
  NavLink as BSNavLink,
} from 'reactstrap';
import bn from 'utils/bemnames';

const sidebarBackground = {
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
};

const userSettingsContents = [
  { to: '/change_password', name: 'Cambiar Contraseña', exact:false, Icon: FaKey },
];

const managementContents = [
  { to: '/vehicles', name: 'Vehículos', exact:false, Icon: FaCarAlt },
  { to: '/work_orders', name: 'OTs', exact:false, Icon: FaFile },
  { to: '/drivers', name: 'Choferes', exact:false, Icon: FaUsersCog },
  { to: '/users', name: 'Usuarios', exact:false, Icon: FaUsers },
  { to: '/brands', name: 'Marcas/Modelos', exact:false, Icon: FaCheck },
  { to: '/owners', name: 'Dueños', exact:false, Icon: FaUserTie },
  { to: '/edit_requests', name: 'Solicitudes de edición', exact:false, Icon: FaClipboardCheck },
  { to: '/create_requests', name: 'Solicitudes de creación', exact:false, Icon: FaClipboardCheck },
];

const rootItems = [
  { to: '/', name: 'Inicio', exact: true, Icon: MdDashboard },
  { to: '/consumption_analisys', name: 'Analisis de consumo', exact:false, Icon:FaChartLine},
  { to: '/trip_history', name: 'Historial Viajes', exact: false, Icon: FaHistory },
  { to: '/fueling_history', name: 'Historial Cargas', exact:false, Icon:FaGasPump},
];

const bem = bn.create('sidebar');

class Sidebar extends React.Component {
  state = {
    isOpenComponents: false,
    isOpenContents: false,
    isOpenPages: false,
    isOpenManagement: false,
    isOpenUserSettings:false,
    logoutRedirect:false,
  };

  handleClick = name => () => {
    this.setState(prevState => {
      const isOpen = prevState[`isOpen${name}`];

      return {
        [`isOpen${name}`]: !isOpen,
      };
    });
  };
  logout = () =>{
    this.props.logout();
  }

  componentDidUpdate(prevProps){
    if(prevProps.auth !== this.props.auth){
      this.setState({
        logoutRedirect:true,
      })
    }
  }

  render() {
    if(this.state.logoutRedirect){
      return(
        <Redirect
        to="/login"
        />
      )
    }
    return (
      <aside className={bem.b()}>
        <div className={bem.e('background')} style={sidebarBackground} />
        <div className={bem.e('content')}>
          <Navbar>
            <span className="navbar-brand d-flex">
              <span className="text-white">
                Control de Flota
              </span>
            </span>
          </Navbar>
          <Nav vertical>
            {rootItems.map(({ to, name, exact, Icon }, index) => (
              <NavItem key={index} className={bem.e('nav-item')}>
                <BSNavLink
                  id={`navItem-${name}-${index}`}
                  className="text-uppercase"
                  tag={NavLink}
                  to={to}
                  activeClassName="active"
                  exact={exact}
                >
                  <Icon className={bem.e('nav-item-icon')} />
                  <span className="">{name}</span>
                </BSNavLink>
              </NavItem>
            ))}
            <NavItem
              className={bem.e('nav-item')}
              onClick={this.handleClick('Management')}
            >
              <BSNavLink className={bem.e('nav-item-collapse')}>
                <div className="d-flex">
                  <MdExtension className={bem.e('nav-item-icon')} />
                  <span className=" align-self-start">Administrar</span>
                </div>
                <MdKeyboardArrowDown
                  className={bem.e('nav-item-icon')}
                  style={{
                    padding: 0,
                    transform: this.state.isOpenManagement
                      ? 'rotate(0deg)'
                      : 'rotate(-90deg)',
                    transitionDuration: '0.3s',
                    transitionProperty: 'transform',
                  }}
                />
              </BSNavLink>
            </NavItem>
            <Collapse isOpen={this.state.isOpenManagement}>
              {managementContents.map(({ to, name, exact, Icon }, index) => (
                <NavItem key={index} className={bem.e('nav-item')}>
                  <BSNavLink
                    id={`navItem-${name}-${index}`}
                    className="text-uppercase"
                    tag={NavLink}
                    to={to}
                    activeClassName="active"
                    exact={exact}
                  >
                    <Icon className={bem.e('nav-item-icon')} />
                    <span className="">{name}</span>
                  </BSNavLink>
                </NavItem>
              ))}
            </Collapse>

            <NavItem
              className={bem.e('nav-item')}
              onClick={this.handleClick('UserSettings')}
            >
              <BSNavLink className={bem.e('nav-item-collapse')}>
                <div className="d-flex">
                  <FaRegUserCircle className={bem.e('nav-item-icon')} />
                  <span className=" align-self-start">Mi Usuario</span>
                </div>
                <MdKeyboardArrowDown
                  className={bem.e('nav-item-icon')}
                  style={{
                    padding: 0,
                    transform: this.state.isOpenUserSettings
                      ? 'rotate(0deg)'
                      : 'rotate(-90deg)',
                    transitionDuration: '0.3s',
                    transitionProperty: 'transform',
                  }}
                />
              </BSNavLink>
            </NavItem>
            <Collapse isOpen={this.state.isOpenUserSettings}>
              {userSettingsContents.map(({ to, name, exact, Icon }, index) => (
                <NavItem key={index} className={bem.e('nav-item')}>
                  <BSNavLink
                    id={`navItem-${name}-${index}`}
                    className="text-uppercase"
                    tag={NavLink}
                    to={to}
                    activeClassName="active"
                    exact={exact}
                  >
                    <Icon className={bem.e('nav-item-icon')} />
                    <span className="">{name}</span>
                  </BSNavLink>
                </NavItem>
              ))}
              <NavItem className={bem.e('nav-item')}>
                  <Button
                    className="text-uppercase nav-link custom-button"
                    onClick={this.logout}
                    close ={false}
                    color="transparent"
                  >
                    <MdExitToApp className="cr-sidebar__nav-item-icon"/>
                    <span className="close-fonts">{"Cerrar Sesión"}</span>
                  </Button>
                </NavItem>
            </Collapse>
          </Nav>
        </div>
      </aside>
    );
  }
}

const mapStateToProps = state => ({
  auth:state.auth,
})

export default connect(mapStateToProps,{logout}, null, {pure:false})(Sidebar);
